import React from 'react';
import InteractiveTextViewer from './InteractiveTextViewer';
import PropTypes from 'prop-types';
import styles from './AlgorithmicProblem.module.css';

const AlgorithmicProblemInteractiveTextViewer = ({ 
    formattedText, 
    textId, 
    style = {},
    onWordDisplayed = null
}) => {
    const algorithmicProblemStyle = {
        lineHeight: 1.8,
        fontSize: '1.1rem',
        fontFamily: 'monospace',
        textAlign: 'left',
        ...style
    };

    return (
        <div className={styles['algorithm-text']}>
            <InteractiveTextViewer
                formattedText={formattedText}
                textId={textId}
                baseClassName="algorithmic-problem-interactive-text"
                style={algorithmicProblemStyle}
                source={{ type: 'algorithmic_problem', id: textId }}
                onWordDisplayed={onWordDisplayed}
            />
        </div>
    );
};

AlgorithmicProblemInteractiveTextViewer.propTypes = {
    formattedText: PropTypes.string.isRequired,
    textId: PropTypes.string.isRequired,
    style: PropTypes.object,
    onWordDisplayed: PropTypes.func
};

export default AlgorithmicProblemInteractiveTextViewer;

